import { configureStore } from '@reduxjs/toolkit'

import customerReducer from './redux/customerSlice'
import qiotReducer from './redux/qiotSlice'
import qiotTestReducer from './redux/qiotTestSlice'
import sessionReducer from './redux/sessionSlice'

const store = configureStore({
  reducer: {
    session: sessionReducer,
    customer: customerReducer,
    qiotTest: qiotTestReducer,
    qiot: qiotReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
})

window.store = store

export default store

export const selectCustomer = (state: { customer: CustomerData }) => state.customer

export const selectSession = (state: { session: SessionState }) => state.session

export const selectQiotTest = (state: { qiotTest: QiotTestState }) => state.qiotTest

export const selectQiot = (state: { qiot: QiotState }) => state.qiot
